module.exports = __webpack_public_path__ + "img/curry.4df8c440.png";